import { ApiError, type SeriesAlignmentOutput } from '@schemas'
import type { QueryClient } from '@tanstack/react-query'

export function purgeRevokedSeriesEditions(qc: QueryClient, revoked: Set<string>) {
  void qc.cancelQueries({ queryKey: ['show-series'] })
  const strip = (input: unknown): unknown => {
    if (!input || typeof input !== 'object') return input
    const value = input as Record<string, unknown>
    const safe = (item: unknown) => !revoked.has((item as { showId: string }).showId)
    return {
      ...value,
      ...(Array.isArray(value.pages) ? { pages: value.pages.map(strip) } : {}),
      ...(Array.isArray(value.editions) ? { editions: value.editions.filter(safe) } : {}),
      ...(Array.isArray(value.rows)
        ? {
            rows: (value.rows as SeriesAlignmentOutput['rows']).map(row => ({
              ...row,
              cells: row.cells.filter(safe),
            })),
          }
        : {}),
      ...(value.tray
        ? {
            tray: {
              ...(value.tray as SeriesAlignmentOutput['tray']),
              classes: (value.tray as SeriesAlignmentOutput['tray']).classes.filter(safe),
            },
          }
        : {}),
    }
  }
  qc.setQueriesData({ queryKey: ['show-series'] }, strip)
  void qc.invalidateQueries({ queryKey: ['show-series'] })
}

function isSeriesIdentityMissing(error: unknown) {
  return (
    error instanceof ApiError &&
    error.status === 404 &&
    error.payload?.code === 'SERIES_IDENTITY_NOT_FOUND'
  )
}

export function isSeriesAccessError(error: unknown) {
  return (
    error instanceof ApiError &&
    [401, 403, 404].includes(error.status) &&
    !isSeriesIdentityMissing(error)
  )
}
